<template>
  <ul>
    <system-score-description-row :label="labels.lastEngagement" :score="chatSystemScore.data.lastEngagementScore" />
    <system-score-description-row :label="labels.chatsOpened" :score="chatSystemScore.data.chatsOpenedScore" />
    <system-score-description-row :label="labels.chatsEngaged" :score="chatSystemScore.data.chatsEngagedScore" />
    <system-score-description-row :label="labels.formsFilled" :score="chatSystemScore.data.formsFilledScore" />
    <system-score-description-row :label="labels.chatsJoined" :score="chatSystemScore.data.chatsJoinedScore" />
  </ul>
</template>

<script>
import i18n from '../../../setup/locale/en';
import {mapState} from "vuex";
import SystemScoreDescriptionRow from "@/components/HealthScore/CustomerOverview/SystemScoreDescriptionRow.vue";

export default {
  name: "SystemScoreDescription",
  components: {SystemScoreDescriptionRow},
  data:() => ({
    labels: i18n.clients.healthScore.systemScore,
  }),
  computed: {
    ...mapState('healthScoreStore', ['chatSystemScore']),
  },
}
</script>

<style scoped>

</style>